var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.highlightedPolylines
        ? [
            _vm._l(_vm.highlightedPolylines, function(polyline, index) {
              return [
                _c(
                  "l-polyline",
                  {
                    key: index,
                    attrs: {
                      "lat-lngs": polyline.polylines,
                      weight: 4,
                      color: polyline.color
                    }
                  },
                  [
                    _c("l-tooltip", {
                      domProps: { innerHTML: _vm._s(polyline.label) }
                    })
                  ],
                  1
                )
              ]
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.highlightedPolylines
        ? [
            _c(
              "v-snackbar",
              {
                staticClass: "segments-highlight-snack",
                staticStyle: { cursor: "grab" },
                style: { marginLeft: _vm.$lowResolution ? "" : "405px" },
                attrs: {
                  bottom: true,
                  "auto-height": true,
                  color: "white",
                  left: true,
                  timeout: 0
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                },
                model: {
                  value: _vm.highlightedPolylineSnack,
                  callback: function($$v) {
                    _vm.highlightedPolylineSnack = $$v
                  },
                  expression: "highlightedPolylineSnack"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "snack-highlighted-content" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "snack-highlighted-close",
                        attrs: { right: "", flat: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.removeHighlightedSegments()
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              large: "",
                              title: _vm.$t("global.close"),
                              color: "black"
                            }
                          },
                          [_vm._v("close")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "highligh-intro" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("mapView.highlighting")) +
                          " " +
                          _vm._s(_vm.extraInfo.sectionTitle) +
                          ":\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.highlightedPolylines, function(
                      polyline,
                      sectionKey
                    ) {
                      return _c(
                        "span",
                        {
                          key: sectionKey,
                          staticClass: "section-highlighted",
                          style: _vm.highlightedSectionStyle(polyline.color)
                        },
                        [_vm._v(_vm._s(polyline.label))]
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-713379de", { render: render, staticRenderFns: staticRenderFns })
  }
}